const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/MedicationTag/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        ownMedication: 'Eigenes Medikament',
    },
    __RELATIVE_SOURCE_FILE__
);
